<template>
  <ElForm label-width="0" @submit.native.prevent inline class="elementui-common-form-styles" v-highlight>
    <ElFormItem>
      <ElInput v-model.trim="keyword" :placeholder="placeholder" @keyup.enter.native="search">
        <i slot="append" @click="search" class="el-icon-search"></i>
      </ElInput>
    </ElFormItem>

    <ElFormItem class="bg-transparent">
      <el-button type="primary" @click="$emit('on-set')">添加代理商</el-button>
    </ElFormItem>
  </ElForm>
</template>
<script>
export default {
  name: 'ptomAgentInfoFilter',
  props: {
    mediaData: {
      type: Array
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    search() {
      const params = Object.assign({}, { keyword: this.keyword === '' ? undefined : this.keyword })
      this.$emit('on-search', params)
    }
  },

  data() {
    return {
      keyword: ''
    }
  },
  created() {}
}
</script>
